"use strict";

exports.__esModule = true;
var _RoleList = require("./RoleList");
Object.keys(_RoleList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RoleList[key]) return;
  exports[key] = _RoleList[key];
});
var _RoleListItem = require("./RoleListItem");
Object.keys(_RoleListItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RoleListItem[key]) return;
  exports[key] = _RoleListItem[key];
});